import fr from 'facet-rest';
import Autocomplete from 'Components/UI/Autocomplete';

export const metaOverrideSet = fr.metaOverride()
  .nameOverride(['limit', 'offset', 'sort'], { hidden: true })
  .typeOverride('picklist', {
    _component: () => Autocomplete,
  });
